import { render, staticRenderFns } from "./PlateHGSClassificationView.vue?vue&type=template&id=8cbe8b24&"
import script from "./PlateHGSClassificationView.vue?vue&type=script&lang=js&"
export * from "./PlateHGSClassificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports